<template lang="html">
  <div class="image-upload">
    <file-upload
      class="button-secondary"
      post-action="/api/files"
      extensions="gif,jpg,jpeg,png,webp"
      accept="image/png,image/gif,image/jpeg,image/webp"
      :multiple="false"
      :value="files"
      :headers='headers'
      @input="inputUpdate"
      ref="upload">
      Select files
    </file-upload>

    <span v-if="!$refs.upload || !$refs.upload.active" @click="$refs.upload.active = true">Start upload</span>
    <span v-else @click="$refs.upload.active = false">Stop upload</span>
  </div>
</template>

<script>
import FileUpload from 'vue-upload-component'
import { mapState } from 'vuex'

export default {
  props: [ 'uploadImage' ],
  data() {
    return {
      files : []
    }
  },
  methods : {
    inputUpdate(files) {
      if(files[0].success) {
        const image = files[0].response.file.name
        this.$store.commit('UPDATE_CURRENT_POST', { image })
        if(this.uploadImage) this.uploadImage()
      }
    }
  },
  computed : {
    ...mapState([
      'auth'
    ]),
    headers() {
      return {'Authorization': `Bearer ${this.auth.token}`}
    }
  },
  components : {

    FileUpload
  }
}
</script>

<style lang="css" scoped>
</style>
